export default "__VITE_ASSET__e9563fbf__"